import React, { useState } from 'react';
import {
  Box,
  Typography,
  Switch,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  TextField,
  Card,
  CardContent,
  Tabs,
  Tab,
} from '@mui/material';
import { Headphones } from '@mui/icons-material';

const VoicemailDetectionSettings = ({ 
  voicemailDetection = {
    enabled: false,
    action: 'hangup',
    message: 'Hey {{user_name}}, sorry we could not reach you directly. Please give us a callback if you can.'
  },
  onChange 
}) => {
  const [activeTab, setActiveTab] = useState('static');

  const handleEnabledChange = (event) => {
    const enabled = event.target.checked;
    onChange({
      ...voicemailDetection,
      enabled
    });
  };

  const handleActionChange = (event) => {
    const action = event.target.value;
    onChange({
      ...voicemailDetection,
      action
    });
  };

  const handleMessageChange = (event) => {
    const message = event.target.value;
    onChange({
      ...voicemailDetection,
      message
    });
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Box display="flex" alignItems="center" gap={1}>
            <Headphones />
            <Typography variant="h6">Call Settings</Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            {/* Collapse icon would go here */}
          </Typography>
        </Box>

        <Typography variant="h6" gutterBottom>
          Voicemail Detection
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Hang up or leave a voicemail if a voicemail is detected.
        </Typography>

        <Box mb={2}>
          <FormControlLabel
            control={
              <Switch
                checked={voicemailDetection.enabled}
                onChange={handleEnabledChange}
                color="primary"
              />
            }
            label="Enable voicemail detection"
          />
        </Box>

        {voicemailDetection.enabled && (
          <>
            <Box mb={2}>
              <FormControl component="fieldset">
                <RadioGroup
                  value={voicemailDetection.action}
                  onChange={handleActionChange}
                >
                  <FormControlLabel
                    value="hangup"
                    control={<Radio />}
                    label="Hang up if reaching voicemail"
                  />
                  <FormControlLabel
                    value="leave_message"
                    control={<Radio />}
                    label="Leave a message if reaching voicemail"
                  />
                </RadioGroup>
              </FormControl>
            </Box>

            {voicemailDetection.action === 'leave_message' && (
              <Box>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  sx={{ mb: 2 }}
                >
                  <Tab label="Prompt" value="prompt" />
                  <Tab label="Static Sentence" value="static" />
                </Tabs>

                {activeTab === 'static' && (
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    value={voicemailDetection.message}
                    onChange={handleMessageChange}
                    placeholder="Enter your voicemail message..."
                    helperText="Use {{user_name}} to include the user's name dynamically"
                  />
                )}

                {activeTab === 'prompt' && (
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    placeholder="Enter a prompt for generating the voicemail message..."
                    helperText="The AI will generate a message based on this prompt"
                  />
                )}
              </Box>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default VoicemailDetectionSettings; 